const jQueryBridget = require('jquery-bridget');
const Flickity = require('flickity');
Flickity.setJQuery( $ );
jQueryBridget('flickity', Flickity, $);

export function heroCarousel() {
  const $target = $('#hero-carousel');
  if ($target[0]) {
    const $gallery = $target.flickity({
      cellSelector: '.js-carousel-cell',
      cellAlign: 'left',
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: 5000,
      pauseAutoPlayOnHover: false
    });
    // Flickity instance
    const flkty = $gallery.data('flickity');
    // elements
    const $cellButtonGroup = $('#thumbnail');
    const $cellButtons = $cellButtonGroup.find('.js-thumbnail-nav');
    const $caption = $('#hero').find('.js-caption');
    $cellButtons.eq(0).addClass('is-selected');
    $caption.eq(0).addClass('is-selected');
    // update selected cellButtons
    $gallery.on('change.flickity', function() {
      $cellButtons.filter('.is-selected').removeClass('is-selected');
      $cellButtons.eq(flkty.selectedIndex).addClass('is-selected');
      $caption.removeClass('is-selected');
      $caption.eq(flkty.selectedIndex).addClass('is-selected');
    });
    // select cell on button click
    $cellButtonGroup.on('click', '.js-thumbnail-nav', function() {
      $gallery.flickity('stopPlayer');
      const index = $(this).index();
      $gallery.flickity('select', index);
      $('.js-thumbnail-nav').removeClass('is-selected');
      $(this).addClass('is-selected');
      $caption.removeClass('is-selected');
      $caption.eq(index).addClass('is-selected');
    });
  }
}